import { Injectable } from '@angular/core';
import {Card, CardStocks, CardStocksDetails, Warehouse} from '../core/entities/entities';
import * as Rx from 'rxjs/Rx';
import {HttpService} from '../core/services/http.service';
import {HttpServiceBase} from '../core/services/HttpServiceBase';
import {isNullOrUndefined} from 'util';


export interface CardQuery {
  autocomplete_card_name?: string;
  autocomplete_edition?: string;
  autocomplete_foil?: boolean;
  autocomplete_language?: any;
  categoryId?: number;
  brandId?: number;
  card?:Card;
}

import * as lodash from 'lodash';
import {WarehouseService} from './warehouse.service';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {ResolverService} from '../core/services/resolver.service';

@Injectable()
export class CardService extends HttpServiceBase<Card> {

  private _query: CardQuery ;

  set query(query: CardQuery){
    this.query;
    this._query=query;
    localStorage.setItem('CardService.query', JSON.stringify(this._query));
  }

  get query(){
    if(isNullOrUndefined(this._query)){
      const key_val =localStorage.getItem('CardService.query');
      if( key_val) {
        this._query = JSON.parse(key_val) ;
        if(this._query.card){
          this._query.card = this.fromJson(this._query.card);
        }
      }

    }
    return this._query;
  }

  getUrl() {
    return  'autocomplete/card';
  }

  public search(query: CardQuery): Rx.Observable<Card[]>{

    if(!isNullOrUndefined(environment.constants.minCardAutocompleteLength)) {
      if (
        isNullOrUndefined(query) ||
        isNullOrUndefined(query.autocomplete_card_name) ||
        query.autocomplete_card_name.length < environment.constants.minCardAutocompleteLength
      ){

        return Observable.from([[]]);

      }
    }

    let filters:{} = {name:query.autocomplete_card_name, edition: query.autocomplete_edition, idLanguage: query.autocomplete_language ? query.autocomplete_language : environment.constants.defaultLanguageId , categoryId: query.categoryId, brandId: query.brandId};
    if( filters){
      filters =  Object.keys(filters)
        .filter(k => !isNullOrUndefined(filters[k]) && 'null' != filters[k] && 'undefined' != filters[k] )
        .reduce((previousValue, k) => {
          previousValue[k]=filters[k];
          return previousValue;
        },{});
    }

    const me = this;
    return Rx.Observable.create((observer: any) => {
      ResolverService.instance().spinnerService.show();
      me.httpCall('get', me._url , {params: filters }).subscribe(ret =>  {observer.next(me.fromJsonArray(<any[]>ret || null));  ResolverService.instance().spinnerService.hide();});
    });
  }


  private toCardStocks(json:any): CardStocks {
    const me = this;
    let cardS: CardStocks = Object.assign(new CardStocks(), json);

    cardS.total = cardS.warehouseStocks.reduce((tot, curr) => {
      tot = tot + curr.quantity;
      return tot;
    }, 0);

    cardS.temporary_quantity = cardS.warehouseStocks.reduce((tot, curr) => {
      tot = tot + curr.temporary_quantity;
      return tot;
    }, 0);

    return cardS;
  }

  public cardstocks(query?: CardQuery): Rx.Observable<CardStocks[]>{

    const me = this;

    if(isNullOrUndefined(query)){
      query = me.query;
    }

    if( query.card && query.card.id){
      return Rx.Observable.create((observer: any) => {
        me.httpCall('get', this.getBasePath() + 'cardstocks/general/'+ query.card.id).subscribe(ret => {
          observer.next([me.toCardStocks(ret)]);
        });
      });
    }

    return Rx.Observable.create((observer: any) => {

      me.httpCall('get', this.getBasePath() + 'cardstocks/search' , {params: {name:query.autocomplete_card_name, idLanguage: query.autocomplete_language }}).subscribe(ret => {
        console.log(ret);
        const cardStoks: CardStocks[] = ret.map( d => me.toCardStocks(d));
        observer.next(cardStoks);
      });
    });
  }

  public cardstocks_detail(body: {cardId: any, sortingConditions: any}): Rx.Observable<CardStocksDetails>{

    const me = this;
    return Rx.Observable.create((observer: any) => {
        me.httpCall('post', this.getBasePath() + 'cardstocks/details/', body).subscribe(ret => observer.next(ret));
      });
  }

  public getWarehouses(stocks:CardStocks[]): Observable<Warehouse[]>{
    const me = this;
    return Rx.Observable.create((observer: any) => {
      if(stocks && stocks.length > 0){
        me.warehouseService.dataChange.subscribe(ret => {
          if( ret && ret.length){
            observer.next(lodash.uniq(stocks[0].warehouseStocks.map( s => s.warehouse_id)).map( id => this.warehouseService.data.find(w => w.id === id)).filter(w =>w && !w.virtual && !w.refill));
          }
        })

      } else {
        observer.next([]);
      }


    });


  }

  protected init(): void {
  }

  public getCleanInstance(): Card {
    return new Card();
  }
  constructor(protected http: HttpService, private warehouseService: WarehouseService) {
    super(http);
  }

  reload(id: any) {
    const me = this;
    return Rx.Observable.create((observer: any) => {
      me.httpCall('put', this.getBasePath() + `product/reload_mkm/${id}`).subscribe(ret => observer.next(ret));
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/services/card.service.ts